<script setup lang="ts"></script>

<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="40"
    height="40"
    viewBox="0 0 40 40"
    fill="none"
  >
    <path
      d="M20.001 40C31.0467 40 40.001 31.0457 40.001 20C40.001 8.9543 31.0467 0 20.001 0C8.95528 0 0.000976562 8.9543 0.000976562 20C0.000976562 31.0457 8.95528 40 20.001 40Z"
      fill="#DF0025"
    />
    <path
      d="M14.19 35.07C13.5721 35.0683 12.9799 34.8229 12.542 34.387C12.319 34.1688 12.1454 33.9053 12.0329 33.6143C11.9204 33.3232 11.8717 33.0115 11.89 32.7V7.82099C11.9004 7.23342 12.136 6.67228 12.5482 6.2534C12.9604 5.83453 13.5177 5.58989 14.105 5.56999H26.645C26.9396 5.56746 27.2315 5.62696 27.5017 5.74464C27.7718 5.86231 28.0142 6.03551 28.213 6.25299C28.6198 6.67431 28.8499 7.23537 28.856 7.82099V32.66C28.8794 33.2613 28.6646 33.8476 28.2583 34.2915C27.852 34.7354 27.287 35.0012 26.686 35.031H26.486L14.19 35.07ZM14.628 7.05699H14.306C14.0824 7.02663 13.8559 7.08544 13.6753 7.22072C13.4948 7.356 13.3747 7.5569 13.341 7.77999V32.62C13.3223 32.7332 13.3262 32.8489 13.3525 32.9606C13.3788 33.0723 13.427 33.1776 13.4942 33.2706C13.5614 33.3636 13.6464 33.4423 13.7442 33.5023C13.8419 33.5622 13.9507 33.6022 14.064 33.62H26.444C27.167 33.62 27.489 33.339 27.489 32.575V7.98199C27.5093 7.75833 27.4405 7.53569 27.2973 7.36261C27.1542 7.18952 26.9485 7.08003 26.725 7.05799H25.801C25.7387 7.38396 25.5542 7.67378 25.2852 7.86807C25.0161 8.06236 24.683 8.14641 24.354 8.10299H16.517C16.1818 8.156 15.8392 8.07646 15.5616 7.88122C15.284 7.68597 15.0934 7.39037 15.03 7.05699H14.628Z"
      fill="white"
    />
  </svg>
</template>

<style scoped></style>
